export default __webpack_public_path__ + "static/media/quem_confia.c6bebc29.png";